(function () {
  'use strict';

  const STORAGE_KEY = 'eshopye_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('.eshopye-wishlist-count').forEach((el) => {
      el.textContent = count > 0 ? count : '';

      if (count > 0) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.eshopye-wishlist-btn').forEach((button) => {
      const productId = String(button.dataset.productId);

      const exists = wishlist.some(
        (item) => String(item.id) === productId
      );

      /* Set BOTH classes */
      button.classList.toggle('is-wishlisted', exists);
      button.classList.toggle('active', exists);

      /* Explicit color state */
      if (exists) {
        button.style.color = '#e53935';

        const svg = button.querySelector('svg');

        if (svg) {
          svg.style.fill = '#e53935';
          svg.style.stroke = '#e53935';
          svg.style.color = '#e53935';
        }
      } else {
        button.style.color = '';

        const svg = button.querySelector('svg');

        if (svg) {
          svg.style.fill = '';
          svg.style.stroke = '';
          svg.style.color = '';
        }
      }

      button.setAttribute(
        'aria-label',
        exists ? 'Remove from wishlist' : 'Add to wishlist'
      );

      button.setAttribute(
        'title',
        exists ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });
  }

  function showToast(message) {
    let toast = document.querySelector('.eshopye-wishlist-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'eshopye-wishlist-toast';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('show');

    clearTimeout(toast.timer);

    toast.timer = setTimeout(() => {
      toast.classList.remove('show');
    }, 1800);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.eshopye-wishlist-btn');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const product = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice
    };

    let wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(
      (item) => String(item.id) === String(product.id)
    );

    if (existingIndex !== -1) {
      wishlist.splice(existingIndex, 1);
      showToast('Removed from wishlist');
    } else {
      wishlist.push(product);
      showToast('Added to wishlist ❤️');
    }

    saveWishlist(wishlist);

    /* Update ALL hearts */
    updateWishlistButtons();
    updateWishlistCount();
  });

  function initWishlist() {
    updateWishlistButtons();
    updateWishlistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }

  document.addEventListener('shopify:section:load', initWishlist);

})();